// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"TempHotelResults_iconSync__2yx1s","fa-spin":"TempHotelResults_fa-spin__jEdKO"};